const feraConfig = {
    "environment": "production",
    "apiUrl": "https://api.fera.ai/",
    "apiCdnUrl": "https://cdn.fera.ai/api/",
    "cdnUrl": "https://cdn.fera.ai/js/",
    "appUrl": "https://app.fera.ai/",
    "devMode": false, 
    "showErrors": false,
    "wixAppId": "c9064755-5cc8-4faf-a5a6-41a0150a6640"
};
export default feraConfig;